<template>
  <div class="page">
    <div class="category-list">
      <van-button type="primary" :plain="item.id!=form.categoryId" size="normal" v-for="item in categoryList"
                  @click="onCategoryItemTap(item)">{{ item.name }}
      </van-button>
    </div>
    <van-tabs v-model="form.type" @click="onTypeClick">
      <van-tab title="文件" name="file"></van-tab>
      <van-tab title="文案" name="text"></van-tab>
    </van-tabs>
    <div class="file-list" v-if="form.type=='file'">
      <div class="file-item" v-for="item in fileList">
        <van-image class="file-item-image" :src="item.url" fit="cover" alt="图片文件" :preview-src-list="[item.url]"
                   v-if="item.type=='image'"></van-image>
        <van-image class="file-item-image" src="@/assets/image_other.png" fit="cover" alt="其他文件"
                   v-if="item.type=='file'"></van-image>
        <div class="file-item-button" @click="onCopyClick(item)">下载文件</div>
      </div>
    </div>
    <div class="text-list" v-if="form.type=='text'">
      <div class="text-item" v-for="item in fileList">
        <div class="text-item-text-box">
          <div class="text-item-text">{{ item.text }}</div>
        </div>
        <div class="text-item-button" @click="onCopyTextClick(item)">复制文案</div>
      </div>
    </div>
    <van-pagination v-model="currentPage" :total-items="total" :items-per-page="pageSize"
                    force-ellipses @change="onPaginationChange"></van-pagination>
  </div>
</template>

<script>
import api from "@/apis/api";

export default {
  name: "Home",
  data: function () {
    return {
      categoryList: [],
      fileList: [],
      currentPage: 1,
      pageSize: 50,
      total: 0,
      form: {
        categoryId: "",
        type: "file"
      }
    }
  },
  mounted: function () {
    this.getCategoryList();
  },
  methods: {
    onTypeClick: function () {
      this.fileList = [];
      this.currentPage = 1;
      this.total = 0;
      this.getFileList();
    },
    onCategoryItemTap: function (item) {
      this.form.categoryId = item.id;
      this.fileList = [];
      this.currentPage = 1;
      this.total = 0;
      this.getFileList();
    },
    onPaginationChange: function () {
      this.getFileList();
    },
    onCopyClick: function (row) {
      var a = document.createElement("a");
      a.href = row.url;
      a.click();
    },
    onCopyTextClick: function (row) {
      var _this = this;
      this.$copyText(row.text).then(function (e) {
        _this.$notify({
          type: "success",
          message: "复制成功"
        });
      }, function (e) {
        _this.$notify({
          message: "复制失败！",
          type: "error"
        });
      });
    },
    getCategoryList: function () {
      var _this = this;
      var data = {
        pageCount: 1,
        pageSize: 10000
      };
      api.getTempCategoryList(data).then(function (response) {
        _this.categoryList = response.responseData.categoryList;
        _this.form.categoryId = response.responseData.categoryList[0].id
        _this.getFileList();
      });
    },
    getFileList: function () {
      var _this = this;
      var data = {
        categoryId: _this.form.categoryId,
        type: _this.form.type,
        pageCount: _this.currentPage,
        pageSize: _this.pageSize
      };
      api.getTempList(data).then(function (response) {
        _this.fileList = response.responseData.tempList;
        _this.total = parseInt(response.responseData.totalCount);
      });
    }
  }
}
</script>

<style scoped>
.category-list {
  display: flex;
}

.file-list {
  display: flex;
  flex-wrap: wrap;
}

.file-item-image {
  width: 44vw;
  height: 44vw;
  margin-top: 4vw;
  margin-left: 4vw;
}

.file-item-button {
  width: 44vw;
  height: 8vw;
  margin-left: 4vw;
  font-size: 4vw;
  line-height: 8vw;
  text-align: center;
}

.text-item {
  width: 92vw;
  margin-top: 4vw;
  margin-left: 4vw;
}

.text-item-text-box {
  width: 84vw;
  height: 30vw;
  padding: 4vw;
  font-size: 4vw;
  line-height: 6vw;
  border: 1px solid #888888;
}

.text-item-text {
  width: 84vw;
  height: 30vw;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
}

.text-item-button {
  width: 92vw;
  height: 8vw;
  margin-top: 4vw;
  font-size: 6vw;
  line-height: 8vw;
  text-align: center;
}
</style>
